import type {Icon} from '@primer/octicons-react'
import {clsx} from 'clsx'
import styles from './ForYouStatusIcon.module.css'

export type ForYouStatusIconTone = 'success' | 'attention' | 'danger' | 'neutral' | 'done'

type ForYouStatusIconProps = {
  tone: ForYouStatusIconTone
  icon: Icon
  glyphSize?: 12 | 16 | 24
}

export function ForYouStatusIcon({tone, icon: Icon, glyphSize = 16}: ForYouStatusIconProps) {
  return (
    <span className={clsx(styles.statusIcon, styles[tone])}>
      <span className={styles.glyph}>
        <Icon aria-hidden="true" size={glyphSize} />
      </span>
    </span>
  )
}
